import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Fi from "../Field/Fi";
import Button from "../Button/Button";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckIcon from "@mui/icons-material/Check";
import Grid from "@mui/material/Grid";

export default function CountriesModal({
  open,
  setOpen,
  setParentOpen,
  selectedCountries,
  setSelectedCountries,
}) {
  const [countriesCount, setCountriesCount] = React.useState(
    selectedCountries.length
  );
  const [countriesData, setCountriesData] = React.useState({
    Afghanistan: false,
    Albania: false,
    Algeria: false,
    Andorra: false,
    Angola: false,
    "Antigua and Barbuda": false,
    Argentina: false,
    Armenia: false,
    Australia: false,
    Austria: false,
    Azerbaijan: false,
    Bahamas: false,
    Bahrain: false,
    Bangladesh: false,
  });
  const [filteredData, setFilteredData] = React.useState({ ...countriesData });

  React.useEffect(() => {
    if (selectedCountries.length == 0) {
      reset();
    }
  }, [selectedCountries]);

  const reset = () => {
    const c = { ...countriesData };
    Object.keys(c).forEach((key) => (c[key] = false));
    setCountriesData(c);
    setCountriesCount(0);
    if (selectedCountries.length > 0) setSelectedCountries([]);
  };

  const handleChange = (key) => (e) => {
    if (e.target.checked) {
      setCountriesCount((oldCount) => oldCount + 1);
      setSelectedCountries([...selectedCountries, key]);
    } else {
      setCountriesCount((oldCount) => oldCount - 1);
      setSelectedCountries(selectedCountries.filter((c) => c != key));
    }
    setCountriesData({ ...countriesData, [key]: e.target.checked });
  };

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const keys = Object.keys(countriesData);
    const newKeys = keys.filter((value) => {
      return value.toLowerCase().includes(searchWord.toLowerCase());
    });
    const newFilter = {};
    for (let k in newKeys) {
      newFilter[newKeys[k]] = countriesData[k];
    }
    if (searchWord === "") {
      setFilteredData({ ...countriesData });
    } else {
      setFilteredData(newFilter);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setParentOpen(true);
  };
  const [wordEntered, setWordEntered] = React.useState("");

  return (
    <Modal open={open} onClose={handleClose} hideBackdrop>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          height: 600,
          bgcolor: "#FFFFFF",
          boxShadow:
            "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
          borderRadius: "8px",
          outline: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            padding: "24px",
          }}
        >
          <ArrowBackIcon
            onClick={handleClose}
            sx={{
              color: "primary.main",
              marginLeft: "4px",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          />
          <Typography
            variant="subtitle1"
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="600"
            lineHeight="24px"
            color="black"
            sx={{
              margin: "auto",
            }}
          >
            Select Any Country
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "1px",
            backgroundColor: "#D6D6D6",
          }}
        ></Box>
        <Box
          sx={{
            height: "430px",
            padding: "24px",
            paddingBottom: "20px",
            overflowY: "scroll",
            "::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Fi
            value={wordEntered}
            handleChange={handleFilter}
            label="Search Country"
            height="46.29px"
            endIcon={<SearchIcon sx={{ color: "#808080" }} />}
            sx={{ width: "100%", marginX: "1px" }}
          />
          <Heading text="Countries" />
          <Grid container>
            {Object.keys(filteredData).map((c) => (
              <Grid item xs={6}>
                <CheckboxText
                  text={c}
                  value={countriesData[c]}
                  handleChange={handleChange(c)}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "1px",
            backgroundColor: "#D6D6D6",
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "24px",
            width: "100%",
          }}
        >
          <Box
            sx={{ display: "flex", columnGap: "10px", alignItems: "center" }}
          >
            <CheckIcon
              sx={{ color: "#616161", width: "16px", marginRight: "-2px" }}
            />
            <Typography
              variant="body2"
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              lineHeight="20px"
              color="#616161"
            >
              {`${countriesCount} Selected`}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              color="text.primary"
              sx={{
                textDecoration: "underline",
                "&:hover": { cursor: "pointer" },
                marginRight: "24px",
              }}
              onClick={reset}
            >
              Reset
            </Typography>
            <Button
              variant="contained"
              size="lg"
              txColor="text.primary"
              bgColor="#F9D548"
              sx={{ height: "48px", width: "99px", boxShadow: "none" }}
              onClick={handleClose}
              hoverBg="#F3C04F"
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

function CheckboxText({ text, value, handleChange }) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={handleChange}
          sx={{
            color: "#6200EE",
            "&.Mui-checked": {
              color: "#6200EE",
            },
          }}
        />
      }
      label={
        <Typography
          variant="body1"
          fontFamily="Inter"
          fontSize="16px"
          fontWeight="400"
          lineHeight="24px"
          color="text.primary"
        >
          {text}
        </Typography>
      }
    />
  );
}

function Heading({ text }) {
  return (
    <Typography
      variant="subtitle1"
      fontFamily="Inter"
      fontSize="22px"
      fontWeight="600"
      lineHeight="26px"
      color="text.primary"
      sx={{ marginTop: "24px", marginBottom: "15px" }}
    >
      {text}
    </Typography>
  );
}
